import { render, staticRenderFns } from "./dashboard-home.vue?vue&type=template&id=31c881c8"
import script from "./dashboard-home.vue?vue&type=script&lang=js"
export * from "./dashboard-home.vue?vue&type=script&lang=js"
import style0 from "./dashboard-home.vue?vue&type=style&index=0&id=31c881c8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports